import { z } from 'zod';
export const dateOptionsSchema = z.object({});
export const dateCellSchema = z.string();
//# sourceMappingURL=date.js.map